import helperTemplates from 'shared/mixins/helper-templates';

/**
 * @module
 * search input keydown
 */

const selector = '[data-js-search-results]';
const searchResults = function (el, app) {

    const templateHelper = helperTemplates(app);

    const $document = $(document);
    const $el = $(el);
    const $mask = $('[data-js-search-mask]');
    const $form = $('[data-js-search-form]');
    const $input = $('[data-js-search-form-input]');
    const $buttonGo = $('[data-js-search-form-submit]');
    const $buttonClear = $('[data-js-search-form-clear]');
    let urlSearch = {};
    let statusInput = false;
    let searches = [];
    let delayPages = 0; // fake delay (ms) on response (only for dubugging)
    let delayDocs = 0; // fake delay (ms) on response (only for dubugging)
    let delayFaq = 0; // fake delay (ms) on response (only for dubugging)

    // GO!!
    const init = function () {
        // no search URL, no nuthin.
        if (!nyUrls && !nyUrls.ajaxSearch) {
            app.trigger('msgGlobal', ['Sökfunktionen är inte tillgänglig just nu.', 'searchError', 'error', true, true]);
            $el.addClass('Ge-Search-Results-Outer--error');
            $mask.addClass('Ge-Search-Mask--active');
            return;
        }
        urlSearch.Pages = nyUrls.ajaxSearchPages;
        urlSearch.Docs = nyUrls.ajaxSearchDocs;
        urlSearch.Faq = nyUrls.ajaxSearchFaq;
        urlSearch.Prepare = nyUrls.ajaxPrepareSearch;

        console.log("Init");
        // set up the events
        registerEvents();
        
        // try and submit form (if search input has any value)
        submitForm(false, true, true);
    };

    const registerEvents = function () {
        // initialise the submit button
        submitButtonStatus();
        // button events
        $buttonClear.on('click', clearAll);
        // typing in the search input (reveals/hides)
        $input.on('keyup', submitButtonStatus);
        // submit form
        $form.on('submit', submitForm);

        window.onpopstate = function () {
            const keywords = new URI().query(true)["SearchFor"];
            $input.val( keywords );
            doSearch( keywords );
        };

    };

    // show/hide the "submit" button, depending on if the input is empty or not. Also close the extra results div if nothing in the  search input
    const submitButtonStatus = function () {
        const val = $input.val();
        if (val.length) {
            $buttonGo.addClass('Ge-Search-Submit--active');
        } else {
            $buttonGo.removeClass('Ge-Search-Submit--active');
        }
    };

    // submit the search form
    const submitForm = function (ev, noWarning, noPushUrl ) {

        // stop the page reloading
        if (ev) {
            ev.preventDefault();
        }

        // validation
        const keywords = $input.val().trim();
        // console.log( "keywords: " + keywords );
        if (keywords.length < 2 ||  keywords.length > 255) {
            if (!noWarning) {
                app.trigger('msgGlobal', ['Sökordet måste vara minst två bokstäver', 'searchError', 'warning']);
            }
            return;
        }

        console.log( "submit");

        if (!noPushUrl && window.history && window.history.pushState) {
            var url = new URI().setQuery("SearchFor", keywords);
            window.history.pushState(null, null, url.href());
        }

        doSearch( keywords );

        getAriaLiveStatus().text("Söker");
    }

    const doSearch = function( keywords ) {
        prepareSearch(keywords)
            .then(function (logId) {
                // console.log( "prepare: " + logId );
                $.when(
                    search(keywords, 'pages', urlSearch.Pages, delayPages, logId),
                    search(keywords, 'faq', urlSearch.Faq, delayFaq, logId),
                    search(keywords, 'docs', urlSearch.Docs, delayDocs, logId)
                ).then(function (rp, rf, rd) {
                    if (rp > 0) {
                        getTab("pages").click();
                    }
                    else if (rf > 0) {
                        getTab("faq").click();
                    }
                    else if (rd > 0) {
                        getTab("docs").click();
                    }

                    let statusText = "";
                    if (rp === 0 && rf === 0 && rd === 0) {
                        statusText = "Sökningen gav inga resultat"
                    } else {
                        statusText = "Hittade " + rp + " sidor, " + rf + " frågor och svar, och " + rd + " dokument"
                    }
                    
                    getAriaLiveStatus().text(statusText);
                });
            });
    };

    const prepareSearch = function (keywords) {

        if (searches.indexOf(keywords) !== -1) {
            return $.Deferred().resolve(null);
        }

        searches.push(keywords);

        // console.log( "prepare search: " + urlSearch.Prepare );
        return $.ajax(urlSearch.Prepare, {
            'dataType': 'json',
            'method': 'GET',
            'data': {
                'searchFor': keywords
            }
        }).then( function( r ) {
            return r.result;
        });
    }

    const search = function (keywords, type, apiUrl, delay, logId ) {

        // start process
        beginLoad(type);

        var req = $.ajax(apiUrl, {
            'dataType': 'json',
            'method': 'GET',
            'data': {
                'searchFor': keywords,
                'log': logId
            }
        })
            .then(function (response) {

                // response ok?
                if (response && response.status.toLowerCase() === 'ok') {
                    build(response.result, type);
                    // problem
                } else {
                    notAvailable(type);
                }
                endLoad(type);

                return response.result.matches.length;
            });

        return req;

        // setTimeout(function() {
        //     // ajax call

        // },delay);
    };

    const getPanel = function (type) {
        return $('[data-js-search-result-panel="' + type + '"]');
    }

    const getTab = function (type) {
        return $('[data-js-search-result-tab="' + type + '"]');
    }

    const getAriaLiveStatus = function () {
        return $('[data-js-search-results-a11y]');
    }

    const beginLoad = function (type) {
        const $panel = getPanel(type);
        $panel.find('.Ge-Search-Results-NotAvailable').hide();
        $panel.find('.Ge-Search-Results-Empty').hide();

        getTab(type)
            .addClass('Ge-Search-Results-Tab--loading')
            .removeClass('Ge-Search-Results-Tab--ready');

        $panel
            .addClass('Ge-Search-Results-Content--loading')
            .removeClass('Ge-Search-Results-Content--ready');
    }

    const notAvailable = function (type) {
        getPanel(type).find('.Ge-Search-Results-NotAvailable').show();
    }

    const endLoad = function (type) {
        getPanel(type)
            .removeClass('Ge-Search-Results-Content--loading')
            .addClass('Ge-Search-Results-Content--ready');
        getTab(type)
            .removeClass('Ge-Search-Results-Tab--loading')
            .addClass('Ge-Search-Results-Tab--ready');
    };

    const build = function (result, type) {

        // list of img extensions that will get an image icon
        const imgTypes = ['.jpg', '.png', '.gif', '.jpeg', '.tif', '.tiff', '.bmp', '.ico'];
        // list of paths at level 3 that are shown as ribbons (eg, /Privat/produkter_och_priser/elnat/sa_funker_det) shows ribbons like [privat][elnät]
        const categoriesShown = ['el', 'elnät', 'gas', 'fjärrvärme'];

        let matches = result.matches;



        getPanel(type).find('.Ge-Search-Results-Empty').toggle(matches.length === 0);

        // clear the panel of previous results
        $('[data-js-search-result-list="' + type + '"]').text('');

        // show amount of results
        $('[data-js-search-results-rows-tab="' + type + '"]').text('(' + matches.length + ')');


        if (matches.length) {

            let $templatePre = templateHelper.get('[data-js-search-result-template]');
            let $templatePost = false;
            let $templateRibbonPre = templateHelper.get('[data-js-search-result-ribbon-template]');
            let $templateRibbonPost = false;

            $.each(matches, function (index, node) {
                $templatePost = $templatePre.clone();
                $templatePost.find('[data-js-search-result-template-link]').attr('href', node.url).attr('data-index', index + 1);
                $templatePost.find('[data-js-search-result-template-title]').text(node.title);

                if (node.description && node.description.trim().length) {
                    $templatePost.find('[data-js-search-result-template-text]').text(node.description);
                } else {
                    $templatePost.find('[data-js-search-result-template-text]').remove();
                }
                // FILES
                if (node.ext && node.ext.trim().length) {
                    // remove the ribbon line
                    $templatePost.find('[data-js-search-result-template-ribbons]').remove();
                    // remove the meta line
                    $templatePost.find('[data-js-search-result-template-meta]').remove();
                    // add the download attribute to the link
                    $templatePost.find('[data-js-search-result-template-link]').prop('download', true);
                    // pdf icon
                    if (node.ext.toLowerCase() === '.pdf') {
                        $templatePost.find('[data-js-search-result-template-icon] use').attr('xlink:href', '#icon-file-pdf');
                        // img icon
                    } else if (imgTypes.indexOf(node.ext.toLowerCase()) >= 0) {
                        $templatePost.find('[data-js-search-result-template-icon] use').attr('xlink:href', '#icon-file-img');
                    } // else, leave the regular file icon in the template
                    // add GA beacon
                    $templatePost.find('[data-js-search-result-template-link]').attr('data-js-beacon-click', 'download,' + node.title.replace(',', ''))
                    // SEARCH RESULTS
                } else {
                    // remove the icon
                    $templatePost.find('[data-js-search-result-template-icon]').remove();
                    // for search page results, set the meta line to the url of the page
                    if (node.url && node.url.length > 2) {
                        $templatePost.find('[data-js-search-result-template-meta]').text(node.url);
                    } else {
                        $templatePost.find('[data-js-search-result-template-meta]').remove();
                    }
                    // categories
                    if (node.path && node.path.length) {
                        // private/business colours
                        let $color = null;
                        if (node.path[0] && ['företag', 'privat'].indexOf(node.path[0].name.toLowerCase()) >= 0) {
                            $color = (node.path[0].name.toLowerCase() === 'företag' ? 'Ge-Ribbon--outline-gas' : 'Ge-Ribbon--outline-secondary');
                        }
                        $templateRibbonPost = $templateRibbonPre.clone();
                        $templateRibbonPost.text(node.path[0].name);
                        if ($color) {
                            $templateRibbonPost.addClass($color);
                        }
                        $templatePost.find('[data-js-search-result-template-ribbons]').append($templateRibbonPost);
                        const lvl3 = node.path[1];
                        if (lvl3 && lvl3.name.length && categoriesShown.indexOf(lvl3.name.toLowerCase()) >= 0) {
                            $templateRibbonPost = $templateRibbonPre.clone();
                            $templateRibbonPost.text(node.path[1].name);
                            if ($color) {
                                $templateRibbonPost.addClass($color);
                            }
                            $templatePost.find('[data-js-search-result-template-ribbons]').append($templateRibbonPost);
                        }
                    }
                    // add GA beacon
                    $templatePost.find('[data-js-search-result-template-link]').attr('data-js-beacon-click', 'page-click,' + index + 1);
                }
                $('[data-js-search-result-list="' + type + '"]').append($templatePost);
            });
        }
        else {

        }
        // ga
        app.trigger('beacon', 'search-results-rows,' + type + ',' + matches.length);
    };

    //
    const clearAll = function () {
        // clear results
        $.each(['pages', 'docs', 'faq'], function (indxe, value) {
            $('[data-js-search-result-list="' + value + '"]').text('');
            getPanel(value)
                .removeClass('Ge-Search-Results-Content--loading')
                .removeClass('Ge-Search-Results-Content--ready');
            getTab(value)
                .removeClass('Ge-Search-Results-Tab--loading')
                .removeClass('Ge-Search-Results-Tab--ready');
        });
        // clear field
        $input.val('');
        // ga
        app.trigger('beacon', 'search-results-clear');
    };

    return {
        init: init()
    };
};

searchResults.selector = selector;

export default searchResults;
